import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';
import { SuperAuthService } from '../services/super-auth.service';

const HeaderKey = 'Authorization';

/**
 * Adds the Firebase ID token as a Bearer token to outgoing requests.
 * Use in the admin console where there is no organization context.
 */
export function superAuthBearerInterceptor(
	req: HttpRequest<unknown>,
	next: HttpHandlerFn,
) {
	const superAuth = inject(SuperAuthService);
	const firebaseUser = superAuth.firebaseUser();
	if (!firebaseUser || req.headers.has(HeaderKey)) {
		return next(req);
	}

	return from(firebaseUser.getIdToken()).pipe(
		switchMap((token) => {
			if (!token) return next(req);
			const headers = req.headers.set(HeaderKey, `Bearer ${token}`);
			return next(req.clone({ headers }));
		}),
	);
}
